module.exports = __webpack_public_path__ + "img/dashboard.9e4f4f5f.png";